import { render, staticRenderFns } from "./AddGroupWithUsers.vue?vue&type=template&id=63caf6fc&"
import script from "./AddGroupWithUsers.vue?vue&type=script&lang=js&"
export * from "./AddGroupWithUsers.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupWithUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports